import type {CouponData} from '../types';

import {dateToReadableDate} from '@date-picker';
import {Button, Divider} from '@ds/components';
import {PageLayout} from '@ds/layout';
import paymentSuccess from 'assets/images/pin-payment-success.svg';
import {useLocation, useNavigate} from 'react-router-dom';

import CouponInfoRow from '../components/common/CouponInfoRow/CouponInfoRow';
import CouponStatus from '../components/common/CouponStatus/CouponStatus';
import {COUPON_ROUTES} from '../constants';

const CouponPaymentSuccess: React.FC = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const data = (state ?? {}) as Partial<CouponData>;

  return (
    <PageLayout
      footerPosition="static"
      footer={
        <Button
          fullWidth
          variant="fill"
          color="secondary"
          onClick={() => navigate(COUPON_ROUTES.list)}
        >
          متوجه شدم
        </Button>
      }
    >
      <header className="px-4 py-6 text-center">
        <img className="mx-auto" src={paymentSuccess} alt="" aria-hidden />
        <h1 className="mt-4 text-subtitle-md text-neutral-fg">کوپن با موفقیت ایجاد شد.</h1>
        <p className="mt-1 text-body-sm text-gray-34">
          مبلغ قابل پرداخت در زمان تسویه در اولین موعد از فاکتور شما کسر می‌گردد.
        </p>
      </header>
      <Divider className="bg-gray-02" size={8} />
      <section className="px-4">
        <CouponInfoRow title={data.title ?? ''} subtitle={data.description} value="" />
        <CouponInfoRow title="وضعیت" value={<CouponStatus value={data.status} />} />
        <CouponInfoRow
          title="تاریخ شروع"
          value={
            data.start_time
              ? dateToReadableDate({
                  date: data.start_time,
                  day: true,
                  month: true,
                  year: true
                })
              : ''
          }
        />
        <CouponInfoRow
          title="تاریخ پایان"
          value={
            data.end_time
              ? dateToReadableDate({
                  date: data.end_time,
                  day: true,
                  month: true,
                  year: true
                })
              : ''
          }
          hasBorder={false}
        />
      </section>
    </PageLayout>
  );
};

export default CouponPaymentSuccess;
